/* Unboxly - bevestiging zodra er iets in de winkelwagen belandt.
   Het thema toont alleen een vinkje op de knop zelf; dat valt te weinig op.
   Deze toast verschijnt onderin beeld en verdwijnt vanzelf.
   De teksten worden door snippets/stylesheets.liquid meegegeven in
   window.UNBOXLY_TOAST, zodat ze per taal kloppen. */
(function () {
  if (window.__unboxlyToast) return;
  window.__unboxlyToast = true;

  var tekst = window.UNBOXLY_TOAST || {};
  var T_MET = tekst.metTitel || '{titel} zit in je winkelwagen';
  var T_ZONDER = tekst.zonderTitel || 'Toegevoegd aan je winkelwagen';
  var T_LINK = tekst.link || 'Bekijk winkelwagen';
  var T_URL = tekst.linkUrl || '/cart';

  var el = null;
  var timer = null;

  function build() {
    if (el) return el;
    el = document.createElement('div');
    el.className = 'ub-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');

    var vink = document.createElement('span');
    vink.className = 'ub-toast__vink';
    vink.setAttribute('aria-hidden', 'true');
    vink.textContent = '✓';

    var regel = document.createElement('span');
    regel.className = 'ub-toast__tekst';

    var link = document.createElement('a');
    link.className = 'ub-toast__link';
    link.href = T_URL;
    link.textContent = T_LINK;

    el.appendChild(vink);
    el.appendChild(regel);
    el.appendChild(link);
    document.body.appendChild(el);
    return el;
  }

  function toon(titel) {
    var n = build();
    n.querySelector('.ub-toast__tekst').textContent = titel
      ? T_MET.replace('{titel}', titel)
      : T_ZONDER;
    n.classList.add('is-open');
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      n.classList.remove('is-open');
    }, 4500);
  }

  function titelUit(data) {
    if (!data) return '';
    if (data.items && data.items.length) {
      return data.items[0].product_title || data.items[0].title || '';
    }
    return data.product_title || data.title || '';
  }

  var origineel = window.fetch;
  if (typeof origineel !== 'function') return;

  window.fetch = function () {
    var eerste = arguments[0];
    var url = '';
    if (typeof eerste === 'string') {
      url = eerste;
    } else if (eerste && typeof eerste.url === 'string') {
      url = eerste.url;
    }

    var belofte = origineel.apply(this, arguments);

    if (url && url.indexOf('/cart/add') !== -1) {
      belofte.then(function (res) {
        if (!res || !res.ok) return;
        res
          .clone()
          .json()
          .then(function (data) {
            toon(titelUit(data));
          })
          .catch(function () {
            toon('');
          });
      });
    }

    return belofte;
  };
})();